import { Grid, GridItem } from '@chakra-ui/react';
import { CustomFieldEntityEnum, IOfferingRes } from '@monetize/types/app';
import { MFormField, MText } from '..';
import { ROUTES } from '../../../constants';
import { OFFERING_STATUS_DISPLAY } from '../../../constants/offerings';
import { OFFERING_EDIT_ROLES } from '../../../constants/roles';
import { CustomFieldDataForm } from '../../CustomFields/CustomFieldDataForm';
import { RecordLookupPopover } from './RecordLookupPopover';
import { RecordLookupPopoverHeader } from './RecordLookupPopoverHeader';

export interface OfferingLookupPopoverProps {
  offeringId: string;
  label: string;
  hideEditLink?: boolean;
}

export function OfferingLookupPopover({
  offeringId,
  label,
  hideEditLink,
}: OfferingLookupPopoverProps) {
  return (
    <RecordLookupPopover
      recordId={offeringId}
      endpoint={`/api/offerings/${offeringId}`}
      buttonProps={{ lineClamp: 4 }}
      renderRecord={(record) => {
        const offering = record as IOfferingRes;
        return (
          <>
            <RecordLookupPopoverHeader
              recordId={offering.id}
              href={ROUTES.getOfferingEditRoute(offering.id)}
              recordName={offering.name}
              displayStatus={OFFERING_STATUS_DISPLAY[offering.status]}
              roles={OFFERING_EDIT_ROLES}
              hideEditLink={hideEditLink}
            />

            <Grid gridTemplateColumns="1fr 1fr" rowGap={4} mt={4}>
              <GridItem>
                <MFormField label="Status">
                  <MText>{OFFERING_STATUS_DISPLAY[offering.status]}</MText>
                </MFormField>
              </GridItem>
              {offering.description && (
                <GridItem colSpan={2}>
                  <MFormField label="Description">
                    <MText lineClamp={3}>{offering.description}</MText>
                  </MFormField>
                </GridItem>
              )}
            </Grid>
            <CustomFieldDataForm
              entity={CustomFieldEntityEnum.OFFERING}
              value={
                (
                  offering as IOfferingRes & {
                    customFields?: Record<
                      string,
                      string | number | boolean | string[] | null | undefined
                    >;
                  }
                ).customFields ?? {}
              }
              isReadOnly
              setValue={() => {}}
              fieldColSpan={6}
              mode="modal"
            />
          </>
        );
      }}
    >
      {label}
    </RecordLookupPopover>
  );
}
